import { Button } from '@mui/material';
import { useEffect, useState } from 'react';

import { PharmaCompanyDialog } from 'entities/pharmaceutical-company';

import { Country, CreatePharmaceuticalCompanyDto } from 'shared/api';

type Props = {
  countries: Country[];
  disabled?: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  onSubmit: (data: CreatePharmaceuticalCompanyDto) => void;
};

export const CreatePharmaCompany = ({ countries, disabled = false, isSuccess, isLoading, onSubmit }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isSuccess) setIsOpen(false);
  }, [isSuccess]);

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)} sx={{ alignSelf: 'end' }} disabled={disabled}>
        Add company
      </Button>
      <PharmaCompanyDialog
        title="Add pharmaceutical company"
        isOpen={isOpen}
        countries={countries}
        isLoading={isLoading}
        onClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
      />
    </>
  );
};
